import SolidButton from '../shared/solid-button';
import styles from './cookies-consent-dialog-view.module.css';

import { Dialog, Text, Flex, Button, Checkbox } from '@radix-ui/themes';

interface Props {
  analyticsConsent: boolean;
  setAnalyticsConsent: (value: boolean) => void;
  onSave: () => void;
}

const CookiesConsentDialogView = ({
  analyticsConsent,
  setAnalyticsConsent,
  onSave
}: Props) => {
  console.log('analyticsConsent', analyticsConsent);
  return (
    <Dialog.Root>
      <Dialog.Trigger>
        <button className={styles.Button}>
          <Text size={{ initial: '3', sm: '1' }}>Управление cookies</Text>
        </button>
      </Dialog.Trigger>

      <Dialog.Content maxWidth='450px'>
        <Dialog.Title>Управление cookies</Dialog.Title>
        <Dialog.Description
          size='2'
          mb='4'
        >
          Вы можете управлять файлами cookie. Технические cookies необходимы для
          работы сайта.
        </Dialog.Description>
        <Flex
          direction='column'
          gap='3'
        >
          <Flex
            align='center'
            gap='2'
          >
            <Checkbox
              checked
              disabled
            />
            <Text>Технические cookies</Text>
          </Flex>

          <Flex
            align='center'
            gap='2'
          >
            <Checkbox
              checked={analyticsConsent}
              onCheckedChange={checked => setAnalyticsConsent(Boolean(checked))}
            />
            <Text>Аналитические cookies</Text>
          </Flex>
        </Flex>

        <Flex
          gap='3'
          mt='4'
          justify='end'
        >
          <Dialog.Close>
            <Button
              variant='outline'
              color='gray'
            >
              Отмена
            </Button>
          </Dialog.Close>
          <Dialog.Close>
            <SolidButton onClick={onSave}>Сохранить выбор</SolidButton>
          </Dialog.Close>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default CookiesConsentDialogView;
